// @ is an alias to /src
import Setting from "../../setting.js";
import PageHeader from "@/components/PageHeaderHome.vue";
import Venues from "@/components/Venues.vue";
import Separator from "@/components/Separator.vue";
import Participants from "@/components/Participants.vue";
import Footer from "@/components/Footer.vue";

import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";

SwiperCore.use([Navigation, Pagination]);

export default {
  name: "Home2023",
  components: {
    PageHeader,
    Venues,
    Separator,
    Participants,
    Footer,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      venues: null,
      alphabet: null,
      slideDetailShow: false,
    };
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Scrollbar, A11y], // Pagination           :pagination="{ clickable: true }"
    };
  },
  created() {
    this.axios
      .get(Setting[process.env.NODE_ENV].API + "Venue/GetAll", {
        params: {
          year: 2023,
        },
      })
      .then((response) => {
        if (this.$route.params.season == "SPRING") {
          this.venues = response.data.filter(
            (x) => x.id == 17 || x.id == 18 || x.id == 19 || x.id == 20
          );
        } else if (this.$route.params.season == "FALL") {
          this.venues = response.data.filter(
            (x) =>
              x.id == 21 ||
              x.id == 22 ||
              x.id == 23 ||
              x.id == 24 ||
              x.id == 25 ||
              x.id == 26 ||
              x.id == 27
          );
        }
      });

    this.axios
      .get(Setting[process.env.NODE_ENV].API + "Venue/GetBands", {
        params: {
          year: 2023,
        },
      })
      .then((response) => {
        this.alphabet = response.data;
      });
  },
  methods: {
    onShowHideSlideDetail() {
      if (!this.slideDetailShow) {
        this.slideDetailShow = true;
      } else {
        this.slideDetailShow = false;
      }
    },
    onClick() {
      this.slideDetailShow = false;
    },
  },
};
